/**
 * Created by shubham on 22/5/18.
 */

import { Component, Input } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { HttpService } from '../shared/services/http.service'
import { MdDialog } from '@angular/material';
import { CommonService } from '../shared/services/common.service';
import { DialogComponent } from '../dialog/dialog.component';
import { ActiveInactiveDialogComponent } from '../dialog/dialog.component';

@Component({
    selector:'activate-deactivate',
    template: require('./activate-deactivate.component.html')
})

export class ActivateDeactivateComponent {
    @Input() childData: any;
    @Input() dashboard: any;
    dialogRef;

    constructor(private router: Router, private route: ActivatedRoute, private httpService: HttpService,
                private dialog: MdDialog, private commonService: CommonService) {
    }

    public performAction(status) {
        this.dialogRef = this.dialog.open(ActiveInactiveDialogComponent);

        let actionStatus;
        if(status == 'delete'){
            actionStatus = 'DELETE';
            this.dialogRef.componentInstance.msg = 'user_deactivate_confirm';
        }else if(status == 'active'){
            actionStatus = 'Activate';
            this.dialogRef.componentInstance.msg = 'user_activate_confirm';
        } else{
            actionStatus = 'Deactivate';
            this.dialogRef.componentInstance.msg = 'user_deactivate_confirm';
        }

        this.dialogRef.componentInstance.activeDeactive = true;
        this.dialogRef.componentInstance.dashboard = this.dashboard;
        this.dialogRef.componentInstance.isConfirm = true;
        if(this.dashboard == 'admin'){
            this.dialogRef.componentInstance.note= 'sub_user_del_info';
        }
        this.dialogRef.afterClosed().subscribe(result => {
            if(result) {
                let data = {};
                if(this.dashboard == 'managerList'){
                    data['buAssociationId'] = this.childData.buAssociationId;
                } else{
                    data['id'] = this.childData.id;
                }

                if(this.childData){
                    if(this.childData.applicationName){
                        data['Name'] = this.childData.applicationName;
                    }

                    if(this.childData.Name){
                        data['Name'] = this.childData.Name;
                    } else if(this.childData.firstName && this.childData.lastName){
                        data['Name'] = this.childData.firstName +' '+this.childData.lastName;
                    }

                    if(this.childData.email){
                        data['email'] = this.childData.email;
                    }
                }

                if(status == 'delete'){
                    data['status'] = 'DELETE';
                }else if(status == 'active'){
                    data['active'] = true;
                } else{
                    data['active'] = false;
                }

                let today = new Date();
                let dd = ('0'+today.getDate()).slice(-2);
                let mm = ('0' + (today.getMonth()+1)).slice(-2);
                let yyyy = today.getFullYear();
                data['deletionDate'] = yyyy+''+mm+''+dd;

                if(this.dashboard == 'admin'){
                    this.httpService.postRequest(data,'userRegistrationsApi/v1/deletePartner/'+this.childData.id).subscribe(
                        res => {
                            this.saveResponse(res,status);
                        },
                        err => { this.httpService.onEnd(); }
                    );

                } else if(this.dashboard == 'partners'){
                    this.httpService.postRequest(data,'partnerOperationsApi/v1/deleteCompanyUser/'+data['id']).subscribe(
                        res => {
                            this.saveResponse(res,status);
                        },
                        err => { this.httpService.onEnd(); }
                    );
                } else if(this.dashboard == 'adminList'){
                    this.httpService.postRequest(data,'superUserOperationsApi/v1/adminActiveState').subscribe(
                        res => {
                            this.saveResponse(res,status);
                        },
                        err => { this.httpService.onEnd(); }
                    );
                } else if(this.dashboard == 'managerList'){
                    this.httpService.postRequest(data,'superUserOperationsApi/v1/countryBusinessUnitManagerActiveState?active='+data['active']).subscribe(
                        res => {
                            this.saveResponse(res,status);
                        },
                        err => { this.httpService.onEnd(); }
                    );
                }else if(this.dashboard == 'applicationList'){
                    this.httpService.getRequest('applicationOperationApi/v1/deleteApplication/'+data['id']).subscribe(
                        res => {
                            this.saveResponse(res,status);
                        },
                        err => { this.httpService.onEnd(); }
                    );
                }

            }
            this.dialogRef = null;
        });
    }

    public saveResponse(res,status) {
        this.httpService.onEnd();
        let statusTxt;
        if(res){
            if(status == 'delete'){
                statusTxt = 'del_rqst_submission_notify';
            } else{
                statusTxt = 'Updated Successfully';
            }
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = statusTxt;

            if(this.dashboard == 'admin'){
                this.commonService.changeAdminDashboardData();
            } else if(this.dashboard == 'partners'){
                this.commonService.changePartnersDashboardData();
            } else if(this.dashboard == 'adminList'){
                this.commonService.changeAdminListDashboardData();
            } else if(this.dashboard == 'managerList'){
                this.commonService.changeManagerListDashboardData();
            }else if(this.dashboard == 'applicationList'){
                this.commonService.changeApplicationListDashboardData();
            }
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/activate-deactivate-request/activate-deactivate.component.ts